import { render, staticRenderFns } from "./CardReferenceWidget.vue?vue&type=template&id=c5e18210&scoped=true"
import script from "./CardReferenceWidget.vue?vue&type=script&lang=js"
export * from "./CardReferenceWidget.vue?vue&type=script&lang=js"
import style0 from "./CardReferenceWidget.vue?vue&type=style&index=0&id=c5e18210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e18210",
  null
  
)

export default component.exports